import config from 'config';
let thisSockets = null;

export const startSockets = f => {
  thisSockets = socketCluster.connect(config.socketCluster);
}

export const sockets = f => (thisSockets);
export const on = event => new Promise(resolve => sockets().on(event, resolve));
export const emit = (event, data) =>
  new Promise((resolve, reject) =>
    sockets().emit(event, data, (error, res) => {
      if(error) {
        return reject(error);
      }
      return resolve(res);
    }
));



// WEBPACK FOOTER //
// ./src/common/utils/sockets.js